// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bf-text{align-items:center;background:var(--active-color);bottom:70px;box-shadow:0 0 20px 15px #000;cursor:pointer;display:flex;flex-direction:row;font-size:14px;justify-content:center;padding:12px;position:fixed!important;position:relative;text-align:center;width:100%;z-index:12}.bf-text,.bf-text a{color:#fff}.bf-text svg{position:absolute;right:15px}@media(min-width:768px){.bf-text{bottom:inherit;box-shadow:inherit;position:relative!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
